import axios from 'axios'

export const notifications = {
    state:{
        notifications:[],
        notificationConfig:[]
    }, 
    mutations:{
        notifications(state, data){
            state.notifications = data.notifications
        },
        notificationconfig(state, data){
          state.notificationConfig = data.config
      },
    },
    actions:{
        getNotifications: ({commit}, payload)=>{
            return new Promise((resolve, reject)=>{
                axios.get(`/notifications?username=${payload.username}`)
                // axios.get(`/notifications?username=Layi`)
                .then(({status, data})=>{
                  if(status === 200){
                    resolve(data);
                    commit("notifications", data)
                  }
                })
                .catch((error)=>{
                  reject(error);
                });
              })
        },
        getNotificationConfig: ({commit})=>{
          return new Promise((resolve, reject)=>{
              axios.get('/config/notifications')
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                  commit("notificationconfig", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
      },
        updateNotification: ({commit}, payload)=>{
          console.log('hi')
          return new Promise((resolve, reject)=>{
              axios.put('/notifications', payload)
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
      },
      updateConfig: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
            axios.put('/config/notifications', payload)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
    },
    },
}